<template>
  <el-upload
    class="upload-demo"
    action="#"
    :on-remove="handleRemove"
    multiple
    :limit="maxCount"
    :on-exceed="handleExceed"
    :file-list="uploadfileList"
    v-model="uploadfileList"
    :before-upload="beforeAvatarUpload"
    :http-request="handleFileUpload"
  >
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">
      只能上传wgt文件，且不超过50MB
    </div>
  </el-upload>
</template>
<script>
import { getFileName } from "@/utils/utils";
import { Message } from "element-ui";
import { uploadPacket } from "@/api/system";

export default {
  computed: {},
  props: {
    model: Array,
    maxCount: {
      type: Number
    } // 最大个数
  },
  data() {
    return {
      uploadfileList: [],
      disabled: false,
      loading: false
    };
  },
  watch: {
    model(value) {
      this.setFileList(value);
    }
  },
  created() {
    if (this.model) {
      this.setFileList(this.model);
    }
  },
  methods: {
    /**
     * 设置图片
     * @param img
     */
    setFileList(img) {
      this.uploadfileList = img;
    },
    /**
     * 删除
     * @param file
     * @param fileList
     */
    handleRemove(file, fileList) {
      console.log("handleRemove file",file);
      const listArr = this.uploadfileList;
      console.log("handleRemove listArr",listArr);

      const uid = file.uid;
      const resultListArr = listArr.filter(item => item.uid !== uid);

      this.uploadfileList = resultListArr;
      this.$emit("valueFunc", resultListArr);
    },
    // 处理文件上传操作
    handleFileUpload(file) {
      console.log("handleFileUploadhandleFileUpload file", file);
      this.loading = true;
      const params = {
        file: file.file
      };
      // 调用后端服务器的接口
      uploadPacket(params)
        .then(resp => {
          if (resp.bizcode === 100) {
            const listArr = this.uploadfileList;
            const obj = {
              name: getFileName(resp.data.dbUrl),
              dbUrl: resp.data.dbUrl,
              url: resp.data.accessUrl
            };
            listArr.push(obj);
            this.uploadfileList = listArr;
            this.$emit("valueFunc", listArr);
          } else {
            Message({
              message: resp.msg,
              type: "error",
              duration: 3 * 1000
            });
          }
        })
        .catch(e => {
          this.$message.error(e.message);
          this.$refs.upload.clearFiles();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.maxCount} 个文件`);
    },

    beforeAvatarUpload(file) {
      console.log("file", file);
      console.log("size", file.size);
      console.log("type", file.type);
      const isJPG = [
        "video/mp4",
        "video/avi",
        "video/wmv",
        "video/mpg",
        "video/mpeg",
        "video/mov",
        "video/rm",
        "video/ram",
        "video/flv",
        "video/swf",
      ].includes(file.type);
      // if (!isJPG) {
      //   this.$message.error(
      //       "上传视频只能是 mp4,avi,wmv,mpg,mpeg,mov,rm,ram,flv,swf,wgt 格式!"
      //   );
      // }
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error("上传视频大小不能超过 50MB!");
      }
      return isLt2M;
    }
  }
};
</script>
<style scoped lang="scss"></style>
